import React from 'react';
import {
  UserOutlined,
  CrownOutlined,
  WalletOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
  ProductOutlined,
  GiftOutlined,
  HeartOutlined,
  GatewayOutlined,
  AuditOutlined,
  SettingOutlined,
  TagOutlined,
  GroupOutlined,
  PayCircleOutlined,
  PrinterOutlined,
  HomeOutlined,
  UsergroupAddOutlined,
  HddOutlined,
  BarChartOutlined,
  MessageOutlined,
  BellOutlined,
  SearchOutlined,
} from '@ant-design/icons';

export const allMenu = [
  {
    key: '/dashboard',
    icon: <HomeOutlined />,
    label: 'Tổng quan',
    permission: '',
  },
  {
    key: '/orders',
    icon: <FileTextOutlined />,
    label: 'Đơn hàng',
    permission: 'order.all',
  },
  {
    key: '/product',
    icon: <ProductOutlined />,
    label: 'Sản phẩm',
    permission: 'product.all',
    children: [
      {
        key: '/products',
        icon: <ProductOutlined />,
        label: 'Danh sách',
      },
      {
        key: '/product_collection',
        icon: <ProductOutlined />,
        label: 'Bộ sưu tập',
      },
      {
        key: '/product_option',
        icon: <GatewayOutlined />,
        label: 'Thuộc tính',
      },
      {
        key: '/product_tag',
        icon: <TagOutlined />,
        label: 'Thẻ',
      },
      {
        key: '/product_category',
        icon: <GroupOutlined />,
        label: 'Phân loại',
      },
      {
        key: '/pricing',
        label: 'Bảng giá',
      },
    ],
  },
  {
    key: '/customers',
    icon: <HeartOutlined />,
    label: 'Khách hàng',
    permission: 'customer.all',
  },
  {
    key: '/chats',
    icon: <MessageOutlined />,
    label: 'Chat khách hàng',
    permission: 'customer.all',
  },
  {
    key: '/notifications',
    icon: <BellOutlined />,
    label: 'Thông báo',
    permission: '',
  },
  {
    key: '/debt',
    icon: <AuditOutlined />,
    label: 'Công nợ',
    permission: 'debt.all',
  },
  {
    key: '/vouchers',
    icon: <GiftOutlined />,
    label: 'Mã giảm giá',
    permission: 'voucher.all',
  },
  {
    key: '/website',
    icon: <ShoppingCartOutlined />,
    label: 'Website',
    permission: 'website.all',
    children: [
      {
        key: '/website/report',
        icon: <BarChartOutlined />,
        label: 'Tổng quan',
      },
      {
        key: '/website/setting/general',
        icon: <GatewayOutlined />,
        label: 'Thông tin',
      },
      {
        key: 'website/setting/homepage',
        icon: <HomeOutlined />,
        label: 'Trang chủ',
      },
      {
        key: 'website/setting/payment',
        icon: <PayCircleOutlined />,
        label: 'Cổng thanh toán',
      },
      {
        key: 'website/setting/order',
        icon: <ShoppingCartOutlined />,
        label: 'Chính sách bán hàng',
      },
      {
        key: 'website/setting/shippingfee',
        icon: <HddOutlined />,
        label: 'Phí ship',
      },
      {
        key: 'website/setting/script',
        icon: <GatewayOutlined />,
        label: 'Script',
      },
    ],
  },
  {
    key: '/seo-center',
    icon: <SearchOutlined />,
    label: 'Trung tâm SEO',
    permission: 'website.all',
    children: [
      {
        key: '/seo-center/brand-profile',
        label: 'Hồ sơ thương hiệu',
      },
      {
        key: '/seo-center/social-share',
        label: 'Social Share',
      },
      {
        key: '/seo-center/landing',
        label: 'Landing Page',
      },
      {
        key: '/seo-center/feed',
        label: 'Site Map',
      },
    ],
  },
  {
    key: '/report',
    icon: <BarChartOutlined />,
    label: 'Báo cáo',
    permission: '',
    children: [
      {
        key: '/report/shop',
        icon: <BarChartOutlined />,
        label: 'Báo cáo bán hàng',
      },
    ],
  },
  {
    key: '/setting',
    icon: <SettingOutlined />,
    label: 'Cài đặt',
    permission: 'setting.all',
    children: [
      {
        key: '/setting/user',
        label: 'Người dùng',
      },
      {
        key: '/setting/warehouse',
        label: 'Kho',
      },
      {
        key: '/setting/internal-status',
        label: 'Trạng thái nội bộ',
      },
      {
        key: '/setting/print',
        icon: <PrinterOutlined />,
        label: 'In',
      },
      {
        key: '/loyalty/setting/point/',
        icon: <WalletOutlined />,
        label: 'Tích điểm',
      },
      {
        key: '/setting/pricing-tables',
        label: 'Bảng giá khách hàng',
      },
    ],
  },
  {
    key: '/collaborator',
    icon: <UsergroupAddOutlined />,
    label: 'Cộng tác viên',
    permission: 'setting.all',
    children: [
      {
        key: '/collaborator/commission',
        label: 'Hoa hồng',
      },
      {
        key: '/collaborator/users',
        label: 'Cộng tác viên',
      },
    ],
  },
  {
    key: '/account',
    icon: <UserOutlined />,
    label: 'Tài khoản',
    children: [
      {
        key: '/account/info',
        label: 'Thông tin',
      },
      {
        key: '/account/shoplist',
        label: 'Shop của tôi',
      },
      {
        key: '/account/invitelist',
        label: 'Lời mời truy cập',
      },
      {
        key: '/account/subscription',
        icon: <CrownOutlined />,
        label: 'Gói cước',
      },
    ],
  },
];
